import { jsx, jsxs } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import './button.js';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import './radio-group.js';
import '@radix-ui/react-select';
import './time-input.js';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

const lgColsMap = {
    2: 'lg:grid-cols-2',
    3: 'lg:grid-cols-3',
    4: 'lg:grid-cols-4',
    5: 'lg:grid-cols-5',
    6: 'lg:grid-cols-6',
};
function StatCardGrid({ stats, columns, className }) {
    const cols = columns ?? Math.min(stats.length, 4);
    const lgCols = lgColsMap[cols] ?? 'lg:grid-cols-4';
    return (jsx("div", { className: cn('rounded-xl border bg-card shadow-sm overflow-hidden grid grid-cols-2', lgCols, className), children: stats.map((stat, i) => (jsxs("div", { className: cn('p-5 text-center', i % 2 !== 0 && 'border-l', i >= 2 && 'border-t lg:border-t-0', i === 2 && 'lg:border-l'), children: [jsx("div", { className: cn('text-3xl font-semibold tracking-tight', stat.valueClassName), children: typeof stat.value === 'number' ? stat.value.toLocaleString() : stat.value }), jsx("div", { className: cn('text-xs font-medium uppercase tracking-wider text-muted-foreground mt-1', stat.labelClassName), children: stat.label })] }, stat.label))) }));
}

export { StatCardGrid };
//# sourceMappingURL=StatCardGrid.js.map
